"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.createDateListFromRelativeConfig = exports.generateDateListFromRelativeDateConfig = exports.getStartAndEndDateFromTriggerDate = exports.evaluateFormulaFromTriggerDate = exports.createDateListFromConfigUntil = exports.createDateListFromConfig = exports.generateDateList = void 0;
exports.isDateInConfig = isDateInConfig;
exports.validateAndCreateConfig = validateAndCreateConfig;
exports.validateDateFormula = validateDateFormula;
exports.validateAndCreateRelativeConfig = validateAndCreateRelativeConfig;
const _ = __importStar(require("lodash"));
const common_1 = require("@finley-technologies/common");
const finley_types_1 = require("@finley-technologies/finley-types");
const formula_engine_1 = require("@finley-technologies/formula-engine");
const configs = __importStar(require("./configs"));
const utils = __importStar(require("./utils"));
// _________________ DATE CONFIG _________________
const generateDateList = (baseDateConfigs, enforceUnique = true) => {
    let dateList = [];
    // generate date list from config
    for (const config of baseDateConfigs) {
        // if recurringDateConfig is an array, it is a list of FullDateStr
        if (_.isArray(config)) {
            dateList.push(...config);
        }
        else {
            const createDateList = utils.getDateListCreator(config.type);
            dateList.push(...createDateList(config));
        }
    }
    if (enforceUnique) {
        dateList = _.uniq(dateList);
    }
    return dateList;
};
exports.generateDateList = generateDateList;
const createDateListFromConfig = (config, enforceUnique = true) => {
    const dates = (0, exports.generateDateList)(config.recurringDateConfigs, enforceUnique);
    const exclusions = (0, exports.generateDateList)(config.exclusions, enforceUnique);
    return utils.excludeDates({
        dates,
        exclusions,
    });
};
exports.createDateListFromConfig = createDateListFromConfig;
/**
 * The dates of createDateListFromConfig on or before `until`, without expanding
 * the schedule past it (an open-ended one runs to 2099). Each config still
 * expands a little past `until`, by twice its backward offset plus a week of
 * holiday slack, so a date that a negative offset moves on or before `until`
 * is kept.
 */
const createDateListFromConfigUntil = (config, until, enforceUnique = true) => {
    const capEndDate = (baseDateConfig) => {
        if (_.isArray(baseDateConfig)) {
            return baseDateConfig;
        }
        const backwardOffsetDays = Math.max(0, -(baseDateConfig.offset?.days ?? 0));
        const expandUntil = common_1.date.addDays(until, backwardOffsetDays * 2 + 7);
        return baseDateConfig.endDate > expandUntil
            ? { ...baseDateConfig, endDate: expandUntil }
            : baseDateConfig;
    };
    return (0, exports.createDateListFromConfig)({
        ...config,
        recurringDateConfigs: config.recurringDateConfigs.map(capEndDate),
        exclusions: config.exclusions.map(capEndDate),
    }, enforceUnique).filter((date) => date <= until);
};
exports.createDateListFromConfigUntil = createDateListFromConfigUntil;
function isDateInConfig(date, config) {
    const dateList = (0, exports.createDateListFromConfig)(config);
    return _.includes(dateList, date);
}
function validateAndCreateConfig({ cadence, offsetDays, offsetDayUnit, offsetNonBusinessDayAdjustment, period, weekdays, occurrence, startDate, endDate, frequency, }) {
    // top level checks
    const error = {};
    if (!period) {
        error.period = 'Period is missing.';
    }
    if (!startDate) {
        error.startDate = 'Start date is missing.';
    }
    if (!endDate) {
        error.endDate = 'End date is missing.';
    }
    if (!frequency) {
        error.frequency = 'Frequency is missing.';
    }
    if (!period || !startDate || !endDate || !frequency) {
        return { config: null, error };
    }
    switch (period) {
        case 'calendarDate':
            return configs.calendarDate.validateAndCreateConfig(startDate, endDate, frequency, cadence, offsetDayUnit, offsetDays, offsetNonBusinessDayAdjustment);
        case 'startOf':
            return configs.startOrEndOfPeriod.validateAndCreateConfig('startOf', startDate, endDate, frequency, cadence, offsetDayUnit, offsetDays, offsetNonBusinessDayAdjustment);
        case 'endOf':
            return configs.startOrEndOfPeriod.validateAndCreateConfig('endOf', startDate, endDate, frequency, cadence, offsetDayUnit, offsetDays, offsetNonBusinessDayAdjustment);
        case 'weekday':
            return configs.weekday.validateAndCreateConfig(startDate, endDate, frequency, cadence, offsetDayUnit, offsetDays, offsetNonBusinessDayAdjustment, weekdays);
        case 'weekdayByOccurrence':
            return configs.weekdayByOccurrence.validateAndCreateConfig(startDate, endDate, frequency, cadence, offsetDayUnit, offsetDays, offsetNonBusinessDayAdjustment, weekdays, occurrence);
        default:
            return (0, common_1.finleyAssertUnreachable)(period);
    }
}
// _________________ RELATIVE DATE CONFIG _________________
function validateDateFormula(formula, variables = new Set(['triggerDate'])) {
    return (0, formula_engine_1.getFormulaErrors)(formula, variables);
}
const evaluateFormulaFromTriggerDate = (formula, dateVariables) => {
    const dateFormula = `TEXT(${formula}, "yyyy-mm-dd")`;
    const engine = (0, formula_engine_1.createFormulaEngine)(finley_types_1.FormulaEngine.FullSupportedFormulaEngines.HyperFormula1, [dateFormula], undefined);
    engine.setVariables(dateVariables);
    return engine.evaluateFullDateStr(dateFormula);
};
exports.evaluateFormulaFromTriggerDate = evaluateFormulaFromTriggerDate;
const getStartAndEndDateFromTriggerDate = (dateVariables, config) => {
    const dateRegex = common_1.consts.regExpFullDateStr.source.slice(1, -1);
    const matchRegex = new RegExp(`^\\s*"?(${dateRegex})"?\\s*$`);
    // captured group will be second element in match list
    const startMatch = config.startDateFormula.match(matchRegex);
    const endMatch = config.endDateFormula.match(matchRegex);
    const startDate = startMatch && startMatch.length === 2
        ? startMatch[1]
        : (0, exports.evaluateFormulaFromTriggerDate)(config.startDateFormula, dateVariables);
    const endDate = endMatch && endMatch.length === 2
        ? endMatch[1]
        : (0, exports.evaluateFormulaFromTriggerDate)(config.endDateFormula, dateVariables);
    return { startDate, endDate };
};
exports.getStartAndEndDateFromTriggerDate = getStartAndEndDateFromTriggerDate;
const generateDateListFromRelativeDateConfig = (relativeConfig, dateVariables, enforceUnique = true) => {
    const baseDateConfigs = [];
    for (const config of relativeConfig) {
        // get start and end dates
        const result = (0, exports.getStartAndEndDateFromTriggerDate)(dateVariables, config);
        // create a base date config
        baseDateConfigs.push({
            startDate: result.startDate,
            endDate: result.endDate,
            ...config.baseDateConfig,
        });
    }
    return (0, exports.generateDateList)(baseDateConfigs, enforceUnique);
};
exports.generateDateListFromRelativeDateConfig = generateDateListFromRelativeDateConfig;
const createDateListFromRelativeConfig = (config, dateVariables, enforceUnique = true) => {
    const dates = (0, exports.generateDateListFromRelativeDateConfig)(config.relativeRecurringDateConfig, dateVariables, enforceUnique);
    const exclusions = (0, exports.generateDateListFromRelativeDateConfig)(config.exclusions, dateVariables, enforceUnique);
    return utils.excludeDates({
        dates,
        exclusions,
    });
};
exports.createDateListFromRelativeConfig = createDateListFromRelativeConfig;
function validateAndCreateRelativeConfig({ cadence, offsetDays, offsetDayUnit, offsetNonBusinessDayAdjustment, period, weekdays, occurrence, startDateFormula, endDateFormula, frequency, }) {
    // top level checks
    const error = {};
    if (!period) {
        error.period = 'Period is missing.';
    }
    if (!frequency) {
        error.frequency = 'Frequency is missing.';
    }
    // check if formula exists & is valid
    if (!startDateFormula) {
        error.startDate = 'Start date is missing.';
    }
    else {
        const startFormulaError = validateDateFormula(startDateFormula);
        if (startFormulaError.errorMessages.length > 0) {
            error.startDate = startFormulaError.errorMessages.join('; ');
        }
    }
    if (!endDateFormula) {
        error.endDate = 'End date is missing.';
    }
    else {
        const endFormulaErrors = validateDateFormula(endDateFormula);
        if (endFormulaErrors.errorMessages.length > 0) {
            error.endDate = endFormulaErrors.errorMessages.join('; ');
        }
    }
    if (!period ||
        !frequency ||
        !startDateFormula ||
        !endDateFormula ||
        !_.isEmpty(error)) {
        return { config: null, error };
    }
    switch (period) {
        case 'calendarDate':
            return configs.calendarDate.validateAndCreateRelativeConfig(startDateFormula, endDateFormula, frequency, cadence, offsetDayUnit, offsetDays, offsetNonBusinessDayAdjustment);
        case 'startOf':
            return configs.startOrEndOfPeriod.validateAndCreateRelativeConfig('startOf', startDateFormula, endDateFormula, frequency, cadence, offsetDayUnit, offsetDays, offsetNonBusinessDayAdjustment);
        case 'endOf':
            return configs.startOrEndOfPeriod.validateAndCreateRelativeConfig('endOf', startDateFormula, endDateFormula, frequency, cadence, offsetDayUnit, offsetDays, offsetNonBusinessDayAdjustment);
        case 'weekday':
            return configs.weekday.validateAndCreateRelativeConfig(startDateFormula, endDateFormula, frequency, cadence, offsetDayUnit, offsetDays, offsetNonBusinessDayAdjustment, weekdays);
        case 'weekdayByOccurrence':
            return configs.weekdayByOccurrence.validateAndCreateRelativeConfig(startDateFormula, endDateFormula, frequency, cadence, offsetDayUnit, offsetDays, offsetNonBusinessDayAdjustment, weekdays, occurrence);
        default:
            return (0, common_1.finleyAssertUnreachable)(period);
    }
}
//# sourceMappingURL=generate.js.map